export default __webpack_public_path__ + "static/media/blogSplaceHolder.49cbf4b7.svg";